module.exports = {
  PORT: "3124",
  NODE_ENV: "development",

  SERVER_DEV_URL: "http://localhost:3123",
  SERVER_STAGING_URL: "https://api-golfusion.cloudxier.dev",
  SERVER_PROD_URL: "https://api.golfusion.id",

  SERVER_GOLF_PASS_DEV_URL: "http://localhost:3131",
  SERVER_GOLF_PASS_STAGING_URL: "https://api-golfusionpass.cloudxier.dev",
  SERVER_GOLF_PASS_PROD_URL: "https://api-golfusionpass.cloudxier.com",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "golfusion.cloudxier.dev",
  CLIENT_PROD_HOST: "golfusion.id",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://golfusion.cloudxier.dev",
  CLIENT_PROD_URL: "https://golfusion.id",

  MAIN_WEBSITE_TITLE: "Golfusion | ",
  SITE_NAME: "Golfusion",

  CLIENT_GOLF_PASS_DEV_URL: "http://localhost:3000",
  CLIENT_GOLF_PASS_STAGING_URL: "https://golfusionpass.cloudxier.dev",
  CLIENT_GOLF_PASS_PRODUCTION_URL: "https://golfusionpass.cloudxier.com",
};
